import { toast } from 'sonner';
import { useState, useEffect, useCallback } from 'react';

import { useTranslate } from 'src/locales';
import { WHATSAPP_APP_ID, WHATSAPP_CONFIG_ID } from 'src/config';

declare global {
  interface Window {
    fbAsyncInit?: () => void;
    FB?: any;
  }
}

interface FBAuthResponse {
  authResponse?: {
    code?: string;
  };
}

interface UseConnectWhatsAppProps {
  onSuccess: (data: { main_token: string }) => void;
  onClick?: (value: any) => void;
}

export const useConnectWhatsApp = ({ onSuccess, onClick }: UseConnectWhatsAppProps) => {
  const [isWhatsappConnectSuccess, setIsWhatsappConnectSuccess] = useState(false);
  const { t } = useTranslate('translation');

  useEffect(() => {
    if (!document.getElementById('facebook-jssdk')) {
      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      document.body.appendChild(script);
    }

    window.fbAsyncInit = () => {
      if (window.FB) {
        window.FB.init({
          appId: WHATSAPP_APP_ID,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v20.0',
        });
      }
    };

    const handleMessageEvent = (event: MessageEvent) => {
      if (
        event.origin !== 'https://www.facebook.com' &&
        event.origin !== 'https://web.facebook.com'
      )
        return;

      try {
        const data = JSON.parse(event.data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          // console.log(data.type)
        }
      } catch {
        // Silently fail
      }
    };

    window.addEventListener('message', handleMessageEvent);
    return () => {
      window.removeEventListener('message', handleMessageEvent);
    };
  }, []);

  const connect = useCallback(() => {
    if (onClick) onClick(true);

    if (window.FB) {
      window.FB.login(
        (response: FBAuthResponse) => {
          if (response.authResponse?.code) {
            toast.success(`${t('WHATSAPP_BUSINESS')} ${t('ACCOUNT_VERIFIED_SUCCESSFULLY')}`);
            setIsWhatsappConnectSuccess(true);
            onSuccess({
              main_token: response.authResponse.code,
            });
          } else {
            toast.error(`${t('WHATSAPP_BUSINESS')} ${t('ACCOUNT_VERIFICATION_FAILED')}`);
            setIsWhatsappConnectSuccess(false);
            onSuccess({
              main_token: '',
            });
          }
        },
        {
          config_id: WHATSAPP_CONFIG_ID,
          response_type: 'code',
          override_default_response_type: true,
          extras: {
            setup: {},
            featureType: '',
            sessionInfoVersion: '3',
          },
        }
      );
    } else {
      toast.error(`${t('WHATSAPP_BUSINESS')} ${t('ACCOUNT_VERIFICATION_FAILED')}`);
      setIsWhatsappConnectSuccess(false);
      onSuccess({
        main_token: '',
      });
    }
  }, [onClick, onSuccess]);

  return { connect, isWhatsappConnectSuccess };
};
